import { __assign, __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { CommonWrapper } from '@skbkontur/react-ui/internal/CommonWrapper';
import { getAddonsTheme, getOldTopBarTheme } from '../../lib/theming/ThemeHelpers';
import { TopBarButtonItem } from './TopBarButtonItem';
import { TopBarDivider } from './TopBarDivider';
import { TopBarItem } from './TopBarItem';
import { TopBarOrganizations } from './TopBarOrganizations';
import { TopBarDropdown, TopBarDropdownMenuSeparator, TopBarDropdownUserName } from './TopBarDropdown';
import { TopBarUser } from './TopBarUser';
import { TopBarEnd } from './TopBarEnd';
import { TopBarStart } from './TopBarStart';
import { TopBarLogout } from './TopBarLogout';
import { jsStyles } from './TopBar.styles';
import { TopBarAvatar } from './TopBarAvatar';
/**
 * Шапка
 *
 * `Item({children: node, iconOnly: bool, onClick: func})` – кликабельный элемент шапки
 *
 * `Divider()` – разделитель
 *
 * `TopBarStart({children: node})` – контейнер для элементов в начале шапки
 *
 * `TopBarEnd({children: node})` – контейнер для элементов в конце шапки
 *
 * `Logout({children?: node})` – обёртка над `Item`. По умолчанию выводит локализованный текст
 *
 * `TopBarAvatar({  userName?: string, avatarUrl?: string, userInitials?: string, onLogout?: () => void, cabinetUrl?: string;})` – аватар пользователя
 */
var TopBar = /** @class */ (function (_super) {
    __extends(TopBar, _super);
    function TopBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopBar.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeContext.Consumer, null, function (theme) {
            _this.theme = _this.props.design2021 ? getAddonsTheme(theme) : getOldTopBarTheme(theme);
            return React.createElement(ThemeContext.Provider, { value: _this.theme }, _this.renderMain());
        }));
    };
    TopBar.prototype.renderMain = function () {
        var _a;
        var _b = this.props, children = _b.children, maxWidth = _b.maxWidth, noShadow = _b.noShadow, noMargin = _b.noMargin;
        return (React.createElement(CommonWrapper, __assign({}, this.props),
            React.createElement("div", { className: cn((_a = {},
                    _a[jsStyles.root(this.theme)] = true,
                    _a[jsStyles.noShadow()] = !!noShadow,
                    _a[jsStyles.noMargin()] = !!noMargin,
                    _a)) },
                React.createElement("div", { className: jsStyles.center(), style: { maxWidth: maxWidth } },
                    React.createElement("div", { className: jsStyles.containerWrap(this.theme) },
                        React.createElement("div", { className: jsStyles.container() }, children))))));
    };
    TopBar.__KONTUR_REACT_UI__ = 'TopBar';
    TopBar.Divider = TopBarDivider;
    TopBar.Item = TopBarButtonItem;
    TopBar.Dropdown = TopBarDropdown;
    TopBar.OrganizationsDropdown = TopBarOrganizations;
    TopBar.Start = TopBarStart;
    TopBar.End = TopBarEnd;
    TopBar.ItemStatic = TopBarItem;
    TopBar.User = TopBarUser;
    TopBar.Logout = TopBarLogout;
    TopBar.Avatar = TopBarAvatar;
    TopBar.DropdownMenuSeparator = TopBarDropdownMenuSeparator;
    TopBar.DropdownUserName = TopBarDropdownUserName;
    TopBar.defaultProps = {
        maxWidth: 1166,
        design2021: true,
    };
    TopBar.propTypes = {
        children: PropTypes.node,
        /**
         * Компонент используемый для рендеринга ссылки.
         * Нужно переопределить если вы хотите подставить ссылку для роутера
         */
        logoComponent: PropTypes.any,
        logoHref: PropTypes.string,
        /**
         * Максимальная ширина контейнера в шапке
         */
        maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        /**
         * Отключает отступ снизу
         */
        noMargin: PropTypes.bool,
        /**
         * Отключает тень
         */
        noShadow: PropTypes.bool,
        /**
         * Отключает виджет
         */
        noWidget: PropTypes.bool,
    };
    return TopBar;
}(React.Component));
export { TopBar };
